// extracted by mini-css-extract-plugin
export default {"container":"CategoryTagList_container__eOWmd","pill":"CategoryTagList_pill__mWeYM","pill_text":"CategoryTagList_pill_text__Ev0+S"};